import { NavLink } from "react-router-dom";

const TABS = [["/", "Home"], ["/duels", "Duels"], ["/ranks", "Ranks"], ["/grow", "Grow"], ["/stats", "Stats"], ["/me", "Me"]] as const;
export function TabBar() {
  return <div className="tabbar"><nav aria-label="Main">
    {TABS.map(([to, label]) => <NavLink key={to} to={to} end={to === "/"}>{label}</NavLink>)}
  </nav></div>;
}
